import { getResponseError } from '../util';
export async function getDescriptiveErrorMessage(response, reason) {
    let errorMessage = '';
    try {
        const err = JSON.parse(await response.text());
        errorMessage = err.error.message;
    }
    catch (error) {
        /* do nothing */
    }
    return getResponseError({ response, reason, statusText: errorMessage });
}
